module.exports = __webpack_public_path__ + "img/happy-joyful-friends-talking-laughing.df07ce46.png";